import { firestoreAction } from 'vuexfire'
import db from '../firebase'

const state = {
  extrasFetched: false,
  extras:[],
}
const getters = {
  extras: (state) => {
    return state.extras
  },
 
  extrasFetched: (state) => {
    return state.extrasFetched
  },

}
const mutations={
  logout_extras(state){
    state.extras=[];
    state.extrasFetched=false;
      }
}
const actions = {

  logoutExtras ({commit}) {
    //console.log("extra")
    commit('logout_extras')
},

  removeExtra({},extraID){
    db.collection('extra').doc(extraID).delete()
  },
  saveExtra({},extra){
    extra.uploadDate=  Date.now() 
    db.collection('extra').doc(extra.id).update(extra)
  },
  createExtra({state},extra){
    
    extra.uploadDate=  Date.now() 
    //console.log(extra)
    db.collection('extra').add(
      extra
    ).then(function(docRef) {
      extra.id=docRef.id
      state.extras.push(extra)
  })
  
      },

//Classes

initExtra({state},Id){
  //  (Cl)
  let cases=[];
  let query = db.collection('extra')
  query = query.where('schoolId', '==', Id.schoolId)

query= query.where("class", "in", Id.classes); 
query.get().then(function (querySnapshot) {
  
    querySnapshot.forEach(function (doc) {
              const id = doc.id
              const data = doc.data()
        data.id=id;
              cases.push(data)
            })
                state.extrasFetched=true;
            state.extras= cases
          })
         
    },
    initExtraEHT({state},Id){
      //  (Cl)
      let cases=[];
      let query = db.collection('extra')
      query = query.where('schoolId', '==', Id)
    query.get().then(function (querySnapshot) {
      
        querySnapshot.forEach(function (doc) {
                  const id = doc.id
                  const data = doc.data()
            data.id=id;
                  cases.push(data)
                })
                    state.extrasFetched=true;
                state.extras= cases
              })
             
        },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
